import React from 'react';

const FormContext = React.createContext();
const FieldContext = React.createContext();
const GroupContext = React.createContext();
const SelectContext = React.createContext();

export { FormContext, FieldContext, GroupContext, SelectContext };
